import React from 'react'
import { Card } from '@surecompanies/core_components'
import type { PaymentCase } from '../PaymentDetailModal/PaymentDetailModal.types'
import {
  SectionCardWrapper,
  SectionTitle,
  cardStyle,
} from './PaymentDetailModal.styles'
import { DetailFieldGrid } from './DetailFieldGrid'
import {
  openApplicationDetails,
  openOurPeopDetails,
} from 'routes/ApplicationManager/components/ApplicationsList/ApplicationsListContainer'
import { convertFromISODate } from 'helpers/datetime'

interface EmployeeInformationSectionProps {
  paymentCase: PaymentCase
  onCopy: (text: string) => void
}

export function EmployeeInformationSection({
  paymentCase,
  onCopy,
}: EmployeeInformationSectionProps) {
  return (
    <SectionCardWrapper>
      <Card style={cardStyle}>
        <SectionTitle>Insured Person Information</SectionTitle>
        <DetailFieldGrid
          onCopy={onCopy}
          fields={[
            {
              title: 'First Name',
              value: paymentCase.firstName || 'N/A',
              isCopy: !!paymentCase.firstName,
              copyValue: paymentCase.firstName || undefined,
            },
            {
              title: 'Middle Name',
              value: paymentCase.middleName || 'N/A',
              isCopy: !!paymentCase.middleName,
              copyValue: paymentCase.middleName || undefined,
            },
            {
              title: 'Last Name',
              value: paymentCase.lastName || 'N/A',
              isCopy: !!paymentCase.lastName,
              copyValue: paymentCase.lastName || undefined,
            },
            {
              title: 'Relationship',
              value: paymentCase.relationship || 'N/A',
            },
            {
              title: 'Employment Status',
              value: paymentCase.employmentStatus || 'N/A',
            },
            {
              title: 'Member ID',
              value: paymentCase.memberId || 'N/A',
              isCopy: !!paymentCase.memberId,
              copyValue: paymentCase.memberId || undefined,
            },
            {
              title: 'Company Name',
              value: paymentCase.companyName,
              isCopy: true,
              copyValue: paymentCase.companyName,
            },
            {
              title: 'Our People Link',
              value: 'Link',
              onClick: () => {
                const key = paymentCase.benefit?.employeePublicKey ?? ''
                if (key) openOurPeopDetails(key)
              },
            },
            {
              title: 'App Engine Link',
              value: 'Link',
              onClick: () => {
                openApplicationDetails(paymentCase.benefitId)
              },
            },
            {
              title: 'Date of Birth (MM-DD-YYYY)',
              value: paymentCase.dateOfBirth
                ? convertFromISODate(
                    paymentCase.dateOfBirth,
                    undefined,
                    'MM-DD-YYYY'
                  )
                : 'N/A',
              isCopy: !!paymentCase.dateOfBirth,
              copyValue: paymentCase.dateOfBirth
                ? convertFromISODate(
                    paymentCase.dateOfBirth,
                    undefined,
                    'MM-DD-YYYY'
                  )
                : undefined,
            },
            {
              title: 'SSN',
              value: paymentCase.ssn || 'N/A',
              isCopy: !!paymentCase.ssn,
              copyValue: paymentCase.ssn || undefined,
            },
            {
              title: 'Last 4 SSN',
              value: paymentCase.last4SSN || 'N/A',
              isCopy: !!paymentCase.last4SSN,
              copyValue: paymentCase.last4SSN || undefined,
            },

            // Mailing Address for payment
            {
              title: 'Street Address',
              value: paymentCase.mailingStreetAddress || 'N/A',
              isCopy: !!paymentCase.mailingStreetAddress,
              copyValue: paymentCase.mailingStreetAddress || undefined,
            },
            {
              title: 'City',
              value: paymentCase.mailingCity || 'N/A',
              isCopy: !!paymentCase.mailingCity,
              copyValue: paymentCase.mailingCity || undefined,
            },
            {
              title: 'State',
              value: paymentCase.mailingStateProvince || 'N/A',
              isCopy: !!paymentCase.mailingStateProvince,
              copyValue: paymentCase.mailingStateProvince || undefined,
            },
            {
              title: 'Zipcode',
              value: paymentCase.mailingPostalCode || 'N/A',
              isCopy: !!paymentCase.mailingPostalCode,
              copyValue: paymentCase.mailingPostalCode || undefined,
            },
            {
              title: 'Messages email',
              value: paymentCase.hixmeEmailAlias || 'N/A',
              isCopy: !!paymentCase.hixmeEmailAlias,
              copyValue: paymentCase.hixmeEmailAlias || undefined,
            },
          ]}
        />
      </Card>
    </SectionCardWrapper>
  )
}
